import PropTypes from "prop-types";

/**
 * PropTypes placeholder for Alerts view.
 */
export const alertsPropTypes = {
  alerts: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  filters: PropTypes.object,
  onFilterChange: PropTypes.func,
};
